import { render, staticRenderFns } from "./scratchjr-text.vue?vue&type=template&id=fd17de96"
import script from "./scratchjr-text.vue?vue&type=script&lang=js"
export * from "./scratchjr-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd17de96')) {
      api.createRecord('fd17de96', component.options)
    } else {
      api.reload('fd17de96', component.options)
    }
    module.hot.accept("./scratchjr-text.vue?vue&type=template&id=fd17de96", function () {
      api.rerender('fd17de96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/scratchjr-text.vue"
export default component.exports